import React from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from '../redux/selector/selector';
import { withRouter } from 'react-router-dom';
import { Fragment } from 'react';
import SVGHome from 'root/components/Icon/SVGHome';
class FooterBottom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: false,
        };
    }

    componentDidMount() {
        this.setState(
            {
                isLogin: this.props.user.isLogin,
            },
            this.updatePaddingIsLogin
        );
    }

    componentDidUpdate() {
        if (this.props.user.isLogin !== this.state.isLogin) {
            this.setState(
                {
                    isLogin: this.props.user.isLogin,
                },
                this.updatePaddingIsLogin
            );
        }
    }

    updatePaddingIsLogin() {
        let footerBtmElem = document.getElementById('footer-btm');
        if (footerBtmElem) {
            if (this.state.isLogin) {
                footerBtmElem.classList = 'footer-mobile-isLogin';
            } else {
                footerBtmElem.classList = '';
            }
        }
    }

    render() {
        return (
            <Translation>
                {(t) => (
                    <div className={`content-container ${document.getElementById('seo-footer') ? 'show' : ''}`} id='copyright-container-btm'>
                        <div className='website-footer-bottom'>
                            <div className='brand-row-container'>
                                {/* <div className='powered_by'>
                  <p>{t('global:footer.power-by', 'Powered By')}</p>
                  <SVGHome name='powerby' className="powerby" />
                </div> */}
                                <div className='copyright-container'>
                                    <p>
                                        {t('global:footer.all-right-reserved', 'All rights reserved.', { year: new Date().getFullYear(), merchant: window.globMerchantName })}
                                    </p>
                                    <span>18+</span>
                                </div>
                            </div>
                        </div>
                        <div className='footer-bottom-line'>
                            <div className='brand-row-separator-1 brand-row-line-separator'></div>
                        </div>
                        <div className={this.props.user.isLogin || this.props.screen.isMobile === false ? 'brand-row-separator-35' : 'brand-row-separator-250'}></div>
                    </div>
                )}
            </Translation>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(FooterBottom)));
